import styled from 'styled-components';

const Footer = styled.div`
  margin-top: 1.5rem;
  display: flex;
  flex-direction: row-reverse;
`;

export default Footer;
